module.exports = __webpack_public_path__ + "img/amor-face-5.90261c11.jpg";